<template>
  <div class="flex items-center text-left" style="min-height: 96px;">
    <div class="w-16 h-full flex items-center flex-none md:w-20 bg-white relative" style="min-height: 96px;">
      <img
        v-if="item.image_path"
        :src="item.image_path"
        :alt="item.name"
        loading="lazy"
        class="w-full h-full object-cover">
      <svg v-if="item.bioland" class="w-8 h-8 absolute right-0 bottom-0">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-bioland"></use>
      </svg>
    </div>
    <div class="pl-4">
      <Link
        class="block"
        :href="route('product', { product: item.slug })"
        target="_blank">
        <h2 class="text-base mb-0 md:text-lg md:mb-1">{{ item.name }}</h2>
      </Link>
      <h3 class="text-xs md:text-sm text-black mb-1">
        <span class="mr-2">
          AN. {{ item.item_number }}<span v-if="item.best_before">, Verkaufstage: {{ item.best_before }}</span>
        </span>
        <span v-if="item.attachment_path">
          <a :href="item.attachment_path"
            class="inline-flex items-center text-accent-brown font-bold hover:text-black"
            target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Steckbrief
          </a>
        </span>
      </h3>
      <div class="info-row">
        <span
          v-if="item.weekend_product"
          class="inline-block text-black text-xs md:text-sm">
          Nur am Wochenende
        </span>
        <span
          v-if="item.weekday_availability_readable && item.weekday_availability_readable.length > 0"
          class="inline-block text-black text-xs md:text-sm">
          {{ item.weekday_availability_readable }}
        </span>
        <span
          v-if="isSeasonal"
          class="inline-block text-black text-xs md:text-sm">
          vom <span class="font-bold">{{ orderableFrom }}</span> bis <span class="font-bold">{{ orderableTo }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import { Link } from '@inertiajs/inertia-vue3'

export default {
  name: 'ProductCard',
  components: { Link },
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    isSeasonal() {
      return this.item.orderable_from ? true : false
    },

    orderableFrom() {
      if (!this.isSeasonal) {
        return null
      }

      return format(new Date(this.item.orderable_from), 'dd.LL.')
    },

    orderableTo() {
      if (!this.isSeasonal) {
        return null
      }

      return format(new Date(this.item.orderable_to), 'dd.LL.')
    },
  }
}
</script>
